import Vue from 'vue';
// eslint-disable-next-line
export const navigationEventBus = new Vue();



// WEBPACK FOOTER //
// ./src/components/navigation/navigationEventBus.js